import { render, staticRenderFns } from "./WtWysiwyg.vue?vue&type=template&id=f462ca72&scoped=true&lang=pug&"
import script from "./WtWysiwyg.vue?vue&type=script&lang=js&"
export * from "./WtWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./WtWysiwyg.vue?vue&type=style&index=0&id=f462ca72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f462ca72",
  null
  
)

export default component.exports